import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import TecRmiSvgHtml from "../TecRmiSvgHtml";
import {useHistory} from "react-router-dom";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import {getByModuleId, MODULE_RELAYS_FUSES} from "../Modules";
import appUserRoutes from "../../../appUserRoutes";
import LinkedModal from "../LinkedModal/LinkedModal";

const RelaysFuseBoxDetail = props => {
  const {typeId, showType, getApiPrimaryParams, getModuleData, setPrintData, unsetPrintData} = useTecRmi()
  const history = useHistory()
  const [linkedId, setLinkedId] = useState()
  const [boxDetailHtml, setBoxDetailHtml] = useState(null)

  useEffect(() => () => unsetPrintData(), [])

  useDidMountEffect(() => {
    window.clickOnElement = handleClickOnElement

    const params = {
      ...getApiPrimaryParams(),
      componentTypeId: props.componentTypeId,
      boxConfigurationMappingId: props.boxConfigurationMappingId,
      buildPeriodQualColId: props.buildPeriodQualColId,
    }

    setPrintData(apiUser.tecRmi.relaysFuses.boxDetailHtmlPrint, {
      ...params,
      printView: true,
    })

    apiUser.tecRmi.relaysFuses.boxDetailHtml(params)
      .then(res => setBoxDetailHtml(res.data))
  })

  const handleLinkedModalClose = () => {
    setLinkedId(null)
    window.clickOnElement = handleClickOnElement
  }

  const handleClickOnElement = (id) => {
    if(id.substring(0, 1) === 'b'){
      const data = getModuleData(MODULE_RELAYS_FUSES)

      if(data){
        let path = []
        data.forEach(mainGroup => {
          mainGroup.SubGroups.forEach(subGroup => {
            subGroup.ItemMps.forEach(itemMp => {
              if(itemMp.ItemMpId === parseInt(id.substring(1))){
                path = [
                  mainGroup.MainGroupId,
                  subGroup.SubGroupId,
                  itemMp.ItemMpId,
                ]
              }
            })
          })
        })

        history.push(appUserRoutes.tecRmi.tabModule(typeId, getByModuleId(MODULE_RELAYS_FUSES, 'uriName'), [props.componentTypeId, ...path].join('/')))
      }
    }
  }

  const handleClick = (e) => {
    if(e.target.closest('a') && e.target.closest('a').getAttribute('href')){
      e.preventDefault()

      const href = e.target.closest('a').getAttribute('href').replaceAll('Þ', '')
      const oper = href.replace(/\d+/g, '')
      const id = href.replace(/^\D+/g, '')

      setLinkedId(id)
    }
  }

  return (
    <div>
      {!boxDetailHtml && <LoadingSpinner />}
      {boxDetailHtml && <TecRmiSvgHtml
        html={boxDetailHtml[0]}
        handleClick={handleClick}
        excludeJsFunctions={['clickOnElement']}
      />}
      {linkedId && <LinkedModal
        onClose={handleLinkedModalClose}
        id={linkedId}
        wiringDiagramsFn={apiUser.tecRmi.relaysFuses.linkedWiringDiagrams}
        diagnosticsFn={apiUser.tecRmi.relaysFuses.linkedDiagnostics}
      />}
    </div>
  );
};

RelaysFuseBoxDetail.propTypes = {
  componentTypeId: PropTypes.number.isRequired,
  boxConfigurationMappingId: PropTypes.number.isRequired,
  buildPeriodQualColId: PropTypes.number.isRequired,
};

export default RelaysFuseBoxDetail;